var _a;
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { AddInfo, VisibilityOn, VisibilityOff, IconPadlockBlack, } from '../Icons';
import { Button as ButtonStandard } from 'autenti-components';
import { injectIntl, FormattedMessage } from 'react-intl';
import Tippy from '@tippyjs/react';
import PinInput from 'react-pin-input';
const autentiLogo = (_a = require('./media/autentiLogo.svg')) === null || _a === void 0 ? void 0 : _a.default;
import { format } from 'date-fns';
import { OTP_ERROR_TYPES } from './constants';
const Wrapper = styled.div `
  max-width: 392px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) => props.app === 'SIGN' && `height: 100%;`}
`;
const Title = styled.div `
  color: #0d1e2e;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: -0.48px;
  line-height: 39px;
  margin-bottom: 4px;
`;
const Info = styled.div `
  color: #6c6c6c;
  font-size: 14px;
  letter-spacing: -0.28px;
  line-height: 22px;
  margin-bottom: 16px;
  text-align: center;
  .icon {
    margin-left: 8px;
  }
`;
const DocumentBlockedInfo = styled.div `
  color: #6c6c6c;
  font-size: 14px;
  letter-spacing: -0.28px;
  line-height: 22px;
  margin-bottom: 16px;
  text-align: center;
`;
const OTP = styled.div `
  margin-bottom: 12px;
`;
const InputWrapper = styled.div `
  display: flex;
  align-items: center;
  .icon {
    margin-left: 8px;
  }
`;
const Label = styled.div `
  color: #0d1e2e;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 7px;
  margin-left: 5px;
`;
const Button = styled.button `
  color: #1c92dd;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
  text-decoration: underline;
  cursor: pointer;
  background: transparent;
  border: none;
  &:disabled {
    cursor: not-allowed;
    color: #979797;
  }
`;
const ButtonInfo = styled.div `
  color: #0d1e2e;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
`;
const ButtonSuccessText = styled.div `
  color: #21955f;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 22px;
`;
const Error = styled.div `
  color: #dc493a;
  font-size: 12px;
  letter-spacing: -0.24px;
  line-height: 20px;
  margin-left: 5px;
`;
const DarkTippy = styled(Tippy) `
  background: #0d1e2e;
`;
const TooltipContent = styled.span `
  color: #ffffff;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
`;
const HeaderLogo = styled.img `
  width: 84px;
  height: 16px;
  margin-bottom: 24px;
`;
const Rectangle = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  border-radius: 8px;
  background-color: #f3f2f2;
`;
const SendPasswordContainer = styled.div `
  margin: 30px 0;
`;
const getExceptionType = (exceptionId) => {
    switch (exceptionId) {
        case OTP_ERROR_TYPES.OTP_VALIDATION_FAILED:
        case 'otp.incorrect':
            return 'otpValidationFailed';
        case OTP_ERROR_TYPES.OTP_VALIDATION_FAILED1:
        case 'otp.incorrect1':
            return 'otpValidationFailed1';
        case OTP_ERROR_TYPES.OTP_VALIDATION_FAILED2:
        case 'otp.incorrect2':
            return 'otpValidationFailed2';
        case OTP_ERROR_TYPES.DOCUMENT_TEMPORARILY_BLOCKED_EXCEPTION:
        case 'document.temporarily.blocked':
            return 'documentTemporarilyBlockedException';
        case OTP_ERROR_TYPES.OTP_GENERATION_ATTEMPTS_EXCEEDED:
        case 'hourly.otp.requests.limit.exceeded':
            return 'otpGenerationAttemptsExceeded';
        case OTP_ERROR_TYPES.CODE_INCORRECT:
            return 'codeIncorrect';
        case OTP_ERROR_TYPES.CODE_INCORRECT1:
            return 'codeIncorrect1';
        case OTP_ERROR_TYPES.CODE_INCORRECT2:
            return 'codeIncorrect2';
        case OTP_ERROR_TYPES.OTP_SERVICE_UNKNOWN_EXCEPTION:
            return 'otpServiceUnknownException';
        case OTP_ERROR_TYPES.OTP_AUTH_NOT_FOUND:
            return 'otpAuthNotFound';
        case OTP_ERROR_TYPES.OTP_VALIDATION_ATTEMPTS_LIMIT_EXCEEDED:
            return 'otpValidationAttemptsLimitExceeded';
        default:
            return 'error';
    }
};
const DocumentBlocked = ({ translations, intl: { formatMessage }, resendSms, resendOtpSuccess, phoneNumber, organization, handleSubmit, error, handleUnlockDocument, mode = 'FORM', app = 'SIGN', additionalAuthenticationMethod, }) => {
    const { title, info, infoForm, label, buttonInfo, button, tooltip, resendSmsSuccessText, showInputButton, infoFormCompany, resendButton, on, } = translations;
    const [showPassword, setShowPassword] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [smsPasswordResendButtonDisabled, setSmsPasswordResendButtonDisabled] = useState(false);
    const attemptsLeft = error && error.details && error.details.attemptsLeft;
    const documentBlocked = (attemptsLeft === 0 &&
        error &&
        error.details &&
        error.details.blockedTill) ||
        (error && error.details && error.details.nextOtpCanBeRequestedAt) ||
        (error &&
            error.exceptionId ===
                OTP_ERROR_TYPES.OTP_VALIDATION_ATTEMPTS_LIMIT_EXCEEDED);
    const otp = additionalAuthenticationMethod === 'otp';
    const nationalPersonalNumberSuffix = additionalAuthenticationMethod === 'national-personal-number-suffix';
    const handleSendSms = () => {
        setShowInput(true);
        handleUnlockDocument();
    };
    const handleResendSms = () => {
        setSmsPasswordResendButtonDisabled(true);
        resendSms();
    };
    useEffect(() => {
        if (!resendOtpSuccess) {
            setSmsPasswordResendButtonDisabled(false);
        }
    }, [resendOtpSuccess]);
    useEffect(() => {
        if (nationalPersonalNumberSuffix) {
            setShowInput(true);
        }
    }, []);
    const date = (error && error.details && error.details.blockedTill) ||
        (error && error.details && error.details.nextOtpCanBeRequestedAt);
    const inputRef = useRef(null);
    const clearValues = () => {
        inputRef.current && inputRef.current.clear();
    };
    useEffect(() => {
        if (error) {
            clearValues();
            if (app === 'DOCS') {
                setShowInput(true);
            }
        }
    }, [error]);
    return (React.createElement(Wrapper, { app: app },
        app === 'SIGN' && React.createElement(HeaderLogo, { src: autentiLogo }),
        app === 'DOCS' && (React.createElement(Rectangle, null,
            React.createElement(IconPadlockBlack, { width: 60, height: 60 }))),
        React.createElement(Title, null, formatMessage(title)),
        mode === 'INFO' && (React.createElement(React.Fragment, null,
            organization && (React.createElement(Info, null,
                React.createElement(FormattedMessage, Object.assign({}, info, { values: { name: React.createElement("b", null, organization) } })))),
            React.createElement(ButtonStandard.Primary, { className: "modal-cancel", onClick: () => handleSendSms() }, formatMessage(button)))),
        mode === 'FORM' && !documentBlocked && (React.createElement(React.Fragment, null,
            organization && phoneNumber && (React.createElement(Info, null,
                React.createElement(FormattedMessage, Object.assign({}, infoForm, { values: {
                        name: React.createElement("b", null, organization),
                        phoneNumber: React.createElement("b", null, phoneNumber),
                    } })),
                React.createElement(DarkTippy, { content: React.createElement(TooltipContent, null, formatMessage(tooltip)), placement: "bottom" },
                    React.createElement("span", { className: "icon" },
                        React.createElement(AddInfo, { width: 12, height: 12 }))))),
            organization && nationalPersonalNumberSuffix && (React.createElement(Info, null,
                React.createElement(FormattedMessage, Object.assign({}, infoFormCompany, { values: {
                        name: React.createElement("b", null, organization),
                    } })))),
            showInput ? (React.createElement(OTP, null,
                React.createElement(Label, null, formatMessage(label)),
                React.createElement(InputWrapper, null,
                    React.createElement(PinInput, { focus: true, length: 6, onComplete: (value) => handleSubmit(value), type: "numeric", secret: showPassword ? false : true, inputStyle: {
                            margin: '4px',
                            padding: '3px',
                            MozAppearance: 'textfield',
                            width: '30px',
                            borderRadius: '3px',
                            fontSize: '1rem',
                            height: '36px',
                            lineHeight: '1rem',
                            backgroundColor: '#f4f8fb',
                            color: '#0d1e2e',
                            border: `${error ? '1px solid red' : '1px solid #6c6c6c'}`,
                        }, inputFocusStyle: { border: '1px solid #1c92dd' }, ref: inputRef }),
                    React.createElement("div", { className: "icon", onClick: () => setShowPassword(!showPassword) }, showPassword ? React.createElement(VisibilityOn, null) : React.createElement(VisibilityOff, null))),
                error && (React.createElement(Error, null, formatMessage(translations[getExceptionType(`${error.exceptionId}${attemptsLeft}`)]))))) : (React.createElement(SendPasswordContainer, null,
                React.createElement(ButtonStandard.Primary, { onClick: () => handleSendSms() }, formatMessage(showInputButton)))),
            otp && (React.createElement(React.Fragment, null,
                React.createElement(ButtonInfo, null, formatMessage(buttonInfo)),
                resendOtpSuccess ? (React.createElement(ButtonSuccessText, null, formatMessage(resendSmsSuccessText))) : (React.createElement(Button, { disabled: !showInput || smsPasswordResendButtonDisabled, onClick: handleResendSms }, formatMessage(resendButton))))))),
        documentBlocked && (React.createElement(DocumentBlockedInfo, null,
            formatMessage(translations[getExceptionType(error.exceptionId)]),
            date && (React.createElement("b", null,
                ' ',
                format(new Date(parseInt(date, 10)), 'dd.MM.yy'),
                ' ',
                formatMessage(on),
                ' ',
                format(new Date(parseInt(date, 10)), 'HH:mm')))))));
};
export default injectIntl(DocumentBlocked);
